<template>
    <div>

        <div id="contact" class="section bg-svg-rainoverforest2">
            <div class="overlay opacity-50"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-10">{{ this.header }}</h1>
                        <p class="lead mb-10">{{ this.subtext }}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'account-delete-approve',
        metaInfo: {
            title: 'Delete Account',
            meta: [
                {
                    'name': 'robots',
                    'content': 'noindex'
                }
            ]
        },
        data () {
            return {
                "header": "Processing...",
                "subtext": "Please wait while we delete your account. This page will automatically update in a few seconds."
            };
        },
        methods: {
        },
        computed: {
            "apiUrl": function(){
                var returnUrl = "";
                switch(location.host){
                    case "sleepjar.com":
                        returnUrl = "https://api.sleepjar.com";
                        break;
                    case "staging.sleepjar.com":
                        returnUrl = "https://staging-api.sleepjar.com";
                        break;
                    default:
                        returnUrl = "http://localhost:3000";
                }
                returnUrl += "/v1/account/delete";
                return returnUrl;
            },
        },
        components: {
        },
        mounted(){
            // use the properties in the querystring to call the API
            fetch(this.apiUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: this.$route.query.token,
                    account_uuid: this.$route.query.account_uuid,
                    is_confirmed: true
                })
            })
            .then(response => response.json())
            .then(data => {
                if(data && data.data && data.data.is_deleted){
                    this.header = "Account deleted";
                    this.subtext = "Your Sleep Jar account has been deleted.";
                }else if(data && data.data && data.data.is_deleted === false){
                    this.header = "Account not deleted";
                    this.subtext = "The request to delete your Sleep Jar account has been invalidated. You may continue using your account.";
                }else{
                    this.header = "Error";
                    this.subtext = "Account deletion request is invalid or has expired.";
                }
            })
            .catch(() => {
                this.header = "Error";
                this.subtext = "Account deletion request is invalid or has expired.";
            });
        }
    }
</script>
